(function() {
var S=Object.defineProperty,H=Object.defineProperties;var B=Object.getOwnPropertyDescriptors;var o=Object.getOwnPropertySymbols;var C=Object.prototype.hasOwnProperty,q=Object.prototype.propertyIsEnumerable;var y=(i,e,a)=>e in i?S(i,e,{enumerable:!0,configurable:!0,writable:!0,value:a}):i[e]=a,w=(i,e)=>{for(var a in e||(e={}))C.call(e,a)&&y(i,a,e[a]);if(o)for(var a of o(e))q.call(e,a)&&y(i,a,e[a]);return i},N=(i,e)=>H(i,B(e));var x=(i,e,a)=>new Promise((d,t)=>{var n=f=>{try{l(a.next(f))}catch(m){t(m)}},c=f=>{try{l(a.throw(f))}catch(m){t(m)}},l=f=>f.done?d(f.value):Promise.resolve(f.value).then(n,c);l((a=a.apply(i,e)).next())});const z=(i,e)=>{var a,d,t;return e&&!((a=e==null?void 0:e.properties)!=null&&a.hidden)&&i`
        <button
            ...${{name:e.name,onClick:e.onclick,type:((d=e.properties)==null?void 0:d.type)==="submit"?"submit":"button",className:`fc-button fc-button--footer${e.id}`,disabled:(t=e==null?void 0:e.properties)==null?void 0:t.disabled,ariaLabel:e.label}}
        >
            ${e.label}
        </button>
    `},L=(i,e,a)=>{var d,t,n;return i`<div className="fc-checkbox">
        <input
            className="fc-checkbox__input"
            type="checkbox"
            id=${a.id}
            name=${e.name}
            value=${a.value}
            onclick=${e.oninput}
            onfocus=${e.onfocus}
            onblur=${e.onblur}
            checked=${a.checked}
            required=${(d=e.properties)==null?void 0:d.mandatory}
            aria-errormessage=${`fc-error-${e.id}`}
            aria-invalid=${!!((t=e.fieldError)!=null&&t.defaultMessage)}
            aria-describedby=${`fc-hint-${e.id}`}
        />
        <label
            className="fc-checkbox__label ${(n=a.properties)!=null&&n.pictureUrl?"fc-checkbox__label--image":""}"
            for=${a.id}
        >
            <div className="fc-checkbox__text">
                ${window.formcentric.formapp.components.imageEmbed(i,a,"original")}
                ${a.label?i`<span>${a.label}</span>`:null}
            </div>
        </label>
    </div>`},A=(i,e)=>{var a,d,t,n,c,l,f,m;return((a=e==null?void 0:e.properties)==null?void 0:a.maxlength)&&i`<div
        className="fc-counter fc-counter__length--${((t=(d=e.properties)==null?void 0:d.maxlength)==null?void 0:t.length)===1?"sm":((c=(n=e.properties)==null?void 0:n.maxlength)==null?void 0:c.length)===2?"md":((f=(l=e.properties)==null?void 0:l.maxlength)==null?void 0:f.length)===3?"lg":"xl"}"
    >
        ${(m=e.value)==null?void 0:m.length}/${e.properties.maxlength}
    </div>`},R=(i,e)=>{var a,d;return(e==null?void 0:e.fieldError)&&i`<div
        className="fc-error"
        role="alert"
        aria-live="polite"
        id=${`fc-error-${e.id}`}
    >
        <span className="fc-sr-only"
            >${e.translation("fieldError.error",{context:e.fieldFocused?"focused":e!=null&&e.label?"unfocused":"unfocused_no_label",field:e==null?void 0:e.label,error:(a=e.fieldError)==null?void 0:a.defaultMessage})}</span
        >
        <span aria-hidden>${(d=e.fieldError)==null?void 0:d.defaultMessage}</span>
    </div>`},T=(i,e)=>{const{errors:a={globalErrors:[],pageErrors:[]},translation:d}=e;return!a.globalErrors.length&&!a.pageErrors.length?null:i`
        <div
            key="fc-global-error"
            className="fc-global-error"
            role="alert"
            aria-live="polite"
            aria-atomic="true"
        >
            <div
                class="fc-global-error__icon-wrapper"
                aria-hidden="true"
            >
                <div className="fc-global-error__icon-wrapper__icon" />
            </div>
            <div class="fc-global-error__list-wrapper">
                ${i`
                    <p>${d("globalError.title")}</p>
                    <ul>
                        ${a.globalErrors.map(t=>i` <li><span>${t.defaultMessage}</span></li>`)}
                        ${a.pageErrors.map(t=>i` <li><span>${t.defaultMessage}</span></li>`)}
                    </ul>
                `}
            </div>
        </div>
    `},V=(i,e)=>{var a;return((a=e.properties)==null?void 0:a.hint)&&e.components.hint(e)},U=(i,e,a)=>{var d,t,n;if((d=e.properties)!=null&&d.pictureUrl)return i`
            <div className="fc-image-embed">
                <img src=${(n=(t=e.properties)==null?void 0:t.pictureUrl)==null?void 0:n[a]} />
            </div>
        `},I=(i,e)=>{var a;return(e==null?void 0:e.label)&&i`<label
        className="fc-label"
        for=${e.id}
        id=${"labelledBy_"+e.id}
    >
        ${e.components.markdown({markdown:e.label,limitedSyntax:!0})}
        ${((a=e.properties)==null?void 0:a.mandatory)&&i`<span
            title="required"
            className="fc-required"
            aria-hidden="true"
            >*</span
        >`}
    </label>`},K=(i,e,a)=>{var d,t,n;return i`<div className="fc-radio">
        <input
            className="fc-radio__input"
            type="radio"
            id=${a.id}
            name=${e.name}
            value=${a.value}
            onclick=${e.oninput}
            onfocus=${e.onfocus}
            onblur=${e.onblur}
            checked=${a.checked}
            required=${(d=e.properties)==null?void 0:d.mandatory}
            aria-errormessage=${`fc-error-${e.id}`}
            aria-invalid=${!!((t=e.fieldError)!=null&&t.defaultMessage)}
            aria-describedby=${`fc-hint-${e.id}`}
        />
        <label
            className="fc-radio__label  ${(n=a.properties)!=null&&n.pictureUrl?"fc-radio__label--image":""}"
            for=${a.id}
        >
            <div className="fc-radio__text">
                ${window.formcentric.formapp.components.imageEmbed(i,a,"original")}
                ${a.label?i`<span>${a.label}</span>`:null}
            </div>
        </label>
    </div>`},P=(i,e)=>{var a;return((a=e.properties)==null?void 0:a.shortHint)&&i`<div className="fc-shorthint"><span>${e.properties.shortHint}</span></div>`},D={button:z,checkBoxOption:L,counter:A,error:R,globalError:T,hint:V,shortHint:P,imageEmbed:U,label:I,radioOption:K},O=(i,e)=>{var a,d,t,n,c,l;return i`
    <div className="fc-field ${(a=e==null?void 0:e.properties)!=null&&a.field_width?e==null?void 0:e.properties.field_width:""}">
        <button
            ...${{id:e.id,name:e.name,onClick:e.onclick,type:((d=e.properties)==null?void 0:d.type)==="submit"?"submit":"button",className:`fc-button fc-button--${((t=e.properties)==null?void 0:t.type)||"back"} ${(n=e==null?void 0:e.properties)!=null&&n.style_class?e==null?void 0:e.properties.style_class:""}`,disabled:(c=e==null?void 0:e.properties)==null?void 0:c.disabled,ariaLabel:e.label,ariaDisabled:(l=e==null?void 0:e.properties)==null?void 0:l.disabled}}
        >
            ${e.label}
        </button>
    </div>
`},G=(i,e)=>{var a,d,t,n,c;return i`
    <div
        className="fc-field ${(a=e==null?void 0:e.properties)!=null&&a.visible?"":"fc-field--hidden"} ${(d=e.properties)!=null&&d.hint?"fc-field--has-hint":""} ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${e!=null&&e.fieldError?"fc-field--has-error":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <div className="fc-calculatedvalue ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""}">
            <div className="fc-calculatedvalue__label">${window.formcentric.formapp.components.label(i,e)}</div>
            <input
                key=${e.id}
                id=${e.id}
                value=${e==null?void 0:e.value}
                className="fc-calculatedvalue__value"
                type="text"
                readonly
            />
            ${window.formcentric.formapp.components.error(i,e)}
        </div>
    </div>
`},j=(i,e)=>{var n,c,l,f;const a=e.logger;let d=document.getElementById(e.id);const t=()=>{d=document.getElementById(e.id);const{frcaptcha:m}=window;if(!m)return a.error("friendlyCaptcha not found"),null;d&&!d.hasAttribute("data-captcha-rendered")&&(m.attach(d),d.addEventListener("frc:widget.complete",u=>{e.clearFieldError(e.name),e.oninput({id:e.id,name:e.name,target:{value:u.detail.response}}),e.onblur({id:e.id,name:e.name})}),d.addEventListener("frc:widget.expired",u=>{e.oninput({id:e.id,name:e.name,target:{value:""}})}),d.addEventListener("frc:widget.error",u=>{}),d.setAttribute("data-captcha-rendered","true"))};return!(d!=null&&d.hasAttribute("data-captcha-rendered"))&&e.fieldSuccess?null:(setTimeout(t,0),i`
        <div
            className="fc-field ${(n=e.properties)!=null&&n.hint?"fc-field--has-hint":""}  ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${(c=e==null?void 0:e.properties)!=null&&c.hidden?"fc-field--hidden":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${e!=null&&e.fieldError?"fc-field--has-error":""}"
        >
            <div className="fc-captcha">
                <div className="fc-captcha__provider">
                    <div className="fc-captcha__provider--small">
                        <div
                            id=${e.id}
                            className="frc-captcha"
                            data-siteKey=${(l=e==null?void 0:e.properties)==null?void 0:l.siteKey}
                            data-api-endpoint=${(f=e==null?void 0:e.properties)==null?void 0:f.endpoint}
                            data-start="none"
                            lang=${e.language.split("-")[0]}
                        ></div>
                        ${window.formcentric.formapp.components.error(i,e)}
                    </div>
                </div>
            </div>
        </div>
    `)},J=(i,e)=>{var n,c,l;const a=e.logger;let d=document.getElementById(e.id);const t=()=>{d=document.getElementById(e.id);const{hcaptcha:f}=window;if(!f)return a.error("hcaptcha not found"),null;d&&!d.hasAttribute("data-captcha-rendered")&&(f.render(e.id,{sitekey:e.properties.siteKey,language:e.language.split("-")[0],callback:m=>{e.clearFieldError(e.name),e.oninput({id:e.id,name:e.name,target:{value:m}}),e.onblur({id:e.id,name:e.name})},"expired-callback":()=>{e.oninput({id:e.id,name:e.name,target:{value:""}})},"error-callback":m=>{}}),d.setAttribute("data-captcha-rendered","true"))};return!(d!=null&&d.hasAttribute("data-captcha-rendered"))&&e.fieldSuccess?null:(setTimeout(t,0),i`
        <div
            id=${`fc-field-${e.id}`}
            className="fc-field ${(n=e.properties)!=null&&n.hint?"fc-field--has-hint":""}  ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${(c=e==null?void 0:e.properties)!=null&&c.hidden?"fc-field--hidden":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${e!=null&&e.fieldError?"fc-field--has-error":""}"
        >
            <div className="fc-captcha">
                <div className="fc-captcha__provider">
                    <div className="fc-captcha__provider--small">
                        <div
                            id=${e.id}
                            className="h-captcha"
                            data-siteKey=${(l=e==null?void 0:e.properties)==null?void 0:l.siteKey}
                        ></div>
                        ${window.formcentric.formapp.components.error(i,e)}
                    </div>
                </div>
            </div>
        </div>
    `)},Q=(i,e)=>{var n,c;const a=e.logger;let d=document.getElementById(e.id);const t=()=>{d=document.getElementById(e.id);const{grecaptcha:l}=window;if(!l)return a.error("reCaptcha not found"),null;d&&!d.hasAttribute("data-captcha-rendered")&&(window.grecaptcha.ready(()=>{window.grecaptcha.render(e.id,{sitekey:e.properties.siteKey,callback:f=>{e.clearFieldError(e.name),e.oninput({id:e.id,name:e.name,target:{value:f}}),e.onblur({id:e.id,name:e.name})},"expired-callback":()=>{e.oninput({id:e.id,name:e.name,target:{value:""}})},"error-callback":f=>{}})}),d.setAttribute("data-captcha-rendered","true"))};return!(d!=null&&d.hasAttribute("data-captcha-rendered"))&&e.fieldSuccess?null:(setTimeout(t,0),i`
        <div
            className="fc-field ${(n=e.properties)!=null&&n.hint?"fc-field--has-hint":""}  ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${(c=e==null?void 0:e.properties)!=null&&c.hidden?"fc-field--hidden":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${e!=null&&e.fieldError?"fc-field--has-error":""}"
        >
            <div className="fc-captcha">
                <div className="fc-captcha__provider fc-captcha__provider--small">
                    <div id=${e.id}></div>
                    ${window.formcentric.formapp.components.error(i,e)}
                </div>
            </div>
        </div>
    `)},W=(i,e)=>{var a,d,t,n,c,l,f;return i`
    <div
        className="fc-field ${(a=e.properties)!=null&&a.hint?"fc-field--has-hint":""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-field--hidden":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${e!=null&&e.fieldError?"fc-field--has-error":""}"
    >
        <div className="fc-captcha ${(t=e==null?void 0:e.properties)!=null&&t.style_class?e==null?void 0:e.properties.style_class:""}">
            <div className="fc-captcha__label">${window.formcentric.formapp.components.label(i,e)}</div>
            <div className="fc-textinput fc-captcha__input">
                <div className="fc-textinput__input">
                    <input
                        type="text"
                        id=${e.id}
                        key=${e.id}
                        name=${e.name}
                        defaultValue=${e.value}
                        oninput=${e.oninput}
                        onfocus=${e.onfocus}
                        onblur=${e.onblur}
                        maxlength=${(n=e.properties)==null?void 0:n.maxlength}
                        disabled=${(c=e.properties)==null?void 0:c.disabled}
                        placeholder=${((l=e.properties)==null?void 0:l.placeholder)||""}
                        readonly=${e==null?void 0:e.fieldSuccess}
                        required
                        aria-errormessage=${`fc-error-${e.id}`}
                        aria-invalid=${!!((f=e.fieldError)!=null&&f.defaultMessage)}
                        aria-describedby=${`fc-hint-${e.id}`}
                    />
                </div>
            </div>
            <div className="fc-captcha__image">${e.components.captcha()}</div>
            ${window.formcentric.formapp.components.hint(i,e)}
            ${window.formcentric.formapp.components.error(i,e)}
            ${window.formcentric.formapp.components.shortHint(i,e)}
        </div>
    </div>
`},X={jCaptcha:W,friendlyCaptcha:j,hCaptcha:J,reCaptcha2:Q},Y=(i,e)=>{var d;const a=X[(d=e==null?void 0:e.properties)==null?void 0:d.provider];return a?a(i,e):null},Z=(i,e)=>{var a,d,t,n,c,l,f;return i`
    <div
        className="fc-field ${(a=e.properties)!=null&&a.hint?"fc-field--has-hint":""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-field--hidden":""} ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <fieldset
            className="fc-fieldset ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""}"
            disabled=${(l=e.properties)==null?void 0:l.disabled}
        >
            <legend className="fc-fieldset__legend">${window.formcentric.formapp.components.label(i,e)}</legend>
            ${window.formcentric.formapp.components.imageEmbed(i,e,"original")}
            <div className="fc-fieldset__options">
                ${(f=e.children)==null?void 0:f.map(m=>window.formcentric.formapp.components.checkBoxOption(i,e,m))}
            </div>
            ${window.formcentric.formapp.components.hint(i,e)}
            ${window.formcentric.formapp.components.shortHint(i,e)}
            ${window.formcentric.formapp.components.error(i,e)}
        </fieldset>
    </div>
`},p=(i,e)=>{var a,d,t,n,c;return i`<div
    className="fc-field ${(a=e.properties)!=null&&a.hint?"fc-field--has-hint":""} ${e!=null&&e.fieldError?"fc-field--has-error":""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-field--hidden":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""} ${e!=null&&e.fieldFocused?"fc-field--focused":""}"
    style="position: relative;"
>
    <div className="fc-select ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""}">
        ${e.components.comboBox(N(w({},e),{imageEmbed:window.formcentric.formapp.components.imageEmbed}))}
        <div class="fc-select__label">
            ${window.formcentric.formapp.components.label(i,e)}
            ${window.formcentric.formapp.components.hint(i,e)}
        </div>
        ${window.formcentric.formapp.components.imageEmbed(i,e,"original")}
        ${window.formcentric.formapp.components.shortHint(i,e)}
        ${window.formcentric.formapp.components.error(i,e)}
    </div>
</div>`},ee=(i,e)=>x(exports,null,function*(){if(e!=null&&e.contentMarkup)return i`${e==null?void 0:e.contentMarkup}`;try{const a=yield(yield fetch((e==null?void 0:e.contentUrl)||"/contentDummyMarkup.html")).text();return i([a])}catch(a){return console.error(a),null}}),ie=(i,e)=>{var a,d,t,n,c;return i`
    <div
        className="
fc-field ${(a=e.properties)!=null&&a.hint?"fc-field--has-hint":""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-field--hidden":""} ${e!=null&&e.fieldError?"fc-field--has-error":""} ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <div className="fc-date ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""}">
            <div className="fc-date__input">${e.components.datePicker(e)}</div>
            <div class="fc-date__label">
                ${window.formcentric.formapp.components.label(i,e)}
                ${window.formcentric.formapp.components.hint(i,e)}
            </div>
            ${window.formcentric.formapp.components.shortHint(i,e)}
            ${window.formcentric.formapp.components.error(i,e)}
        </div>
    </div>
`},ae=(i,e)=>{var a,d,t,n,c,l,f,m,u,$,r;return i`
    <div
        className="fc-field ${(a=e.properties)!=null&&a.hint?"fc-field--has-hint":""}  ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-field--hidden":""} ${e!=null&&e.fieldError?"fc-field--has-error":""} ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <div className="fc-textinput ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""}">
            <div className="fc-textinput__input">
                <input
                    autocomplete=${(l=e.properties)==null?void 0:l.autocomplete}
                    type="email"
                    ...${{id:e.id,key:e.id,name:e.name,defaultValue:e.value,disabled:(f=e.properties)==null?void 0:f.disabled,placeholder:((m=e.properties)==null?void 0:m.placeholder)||"",oninput:e.oninput,onfocus:e.onfocus,readonly:(u=e.properties)==null?void 0:u.readonly,onblur:e.onblur,required:($=e.properties)==null?void 0:$.mandatory,"aria-errormessage":`fc-error-${e.id}`,"aria-invalid":!!((r=e.fieldError)!=null&&r.defaultMessage),"aria-describedby":`fc-hint-${e.id}`}}
                />
            </div>
            <div class="fc-textinput__label">
                ${window.formcentric.formapp.components.label(i,e)}
                ${window.formcentric.formapp.components.hint(i,e)}
            </div>
            ${window.formcentric.formapp.components.shortHint(i,e)}
            ${window.formcentric.formapp.components.error(i,e)}
        </div>
    </div>
`},te=(i,e)=>{var a,d,t;return i`
    <fieldset
        className="fc-fieldset fc-fieldset--field ${(a=e==null?void 0:e.properties)!=null&&a.style_class?e==null?void 0:e.properties.style_class:""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-fieldset--hidden":""}"
    >
        <legend className="fc-fieldset__legend"><span>${e.label}</span></legend>
        <div className="fc-fieldset__options">
            ${(t=e.fieldSetFields)==null?void 0:t.map(n=>{var c,l;return(l=(c=window.formcentric.formapp.templates)==null?void 0:c[n.type])==null?void 0:l.call(c,i,n)})}
        </div>
    </fieldset>
`},de=(i,e)=>{var a,d,t,n,c,l,f;return i`
    <div
        className="
fc-field ${(a=e.properties)!=null&&a.hint?"fc-field--has-hint":""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-field--hidden":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <div className="fc-file ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""}">
            <div className="fc-file__input">
                <button
                    id=${e.id}
                    className="fc-file__button"
                    type="button"
                    name=${e.name}
                    onfocus=${e.onfocus}
                    aria-errormessage=${`fc-error-${e.id}`}
                    aria-invalid=${!!((l=e.fieldError)!=null&&l.defaultMessage)}
                    aria-describedby=${`fc-hint-${e.id}`}
                >
                    ${(f=e.properties)==null?void 0:f.button_label}
                </button>
                ${e.components.fileUploader({id:e.id,onblur:e.onblur,trigger:`#${e.id}`,inline:!1,target:document.querySelector(`[data-fc-form="${e.formId}"]`)})}
            </div>
            <div class="fc-file__label">
                ${window.formcentric.formapp.components.label(i,e)}
                ${window.formcentric.formapp.components.hint(i,e)}
            </div>
            ${window.formcentric.formapp.components.shortHint(i,e)}
            ${window.formcentric.formapp.components.error(i,e)}
        </div>
    </div>
`},ne=(i,e)=>{var a,d,t,n,c;return i`<div className="fc-field--hidden">
    <input
        type="hidden"
        key=${e.id}
        id=${e.id}
        name=${e.name}
        value=${e.value}
        oninput=${e.oninput}
        onfocus=${e.onfocus}
        onblur=${e.onblur}
        autocomplete=${(a=e.properties)==null?void 0:a.autocomplete}
        maxlength=${(d=e.properties)==null?void 0:d.maxlength}
        disabled=${(t=e.properties)==null?void 0:t.disabled}
        placeholder=${((n=e.properties)==null?void 0:n.placeholder)||""}
        readonly=${(c=e.properties)==null?void 0:c.readonly}
    />
</div>`},ce=(i,e)=>{var a,d,t,n,c,l,f,m,u,$,r,v;return i`
    <div
        className="fc-field ${(a=e==null?void 0:e.properties)!=null&&a.hidden?"fc-field--hidden":""} ${(d=e.properties)!=null&&d.hint?"fc-field--has-hint":""} ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${e!=null&&e.fieldError?"fc-field--has-error":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <div className="fc-textinput ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""} ">
            <div className="fc-textinput__input">
                <input
                    key=${e.id}
                    id=${e.id}
                    name=${e.name}
                    defaultValue=${e.value}
                    oninput=${e.oninput}
                    onfocus=${e.onfocus}
                    onblur=${e.onblur}
                    type=${e.properties.type||"text"}
                    autocomplete=${(l=e.properties)==null?void 0:l.autocomplete}
                    maxlength=${(f=e.properties)==null?void 0:f.maxlength}
                    disabled=${(m=e.properties)==null?void 0:m.disabled}
                    placeholder=${((u=e.properties)==null?void 0:u.placeholder)||""}
                    readonly=${($=e.properties)==null?void 0:$.readonly}
                    required=${(r=e.properties)==null?void 0:r.mandatory}
                    aria-errormessage=${`fc-error-${e.id}`}
                    aria-invalid=${!!((v=e.fieldError)!=null&&v.defaultMessage)}
                    aria-describedby=${`fc-hint-${e.id}`}
                />
                ${window.formcentric.formapp.components.counter(i,e)} ${e.components.suggestions(e)}
            </div>
            <div class="fc-textinput__label">
                ${window.formcentric.formapp.components.label(i,e)}
                ${window.formcentric.formapp.components.hint(i,e)}
            </div>
            ${window.formcentric.formapp.components.shortHint(i,e)}
            ${window.formcentric.formapp.components.error(i,e)}
        </div>
    </div>
`},le=(i,e)=>{var a,d,t;return i`<div
        className="fc-layout ${((a=e==null?void 0:e.properties)==null?void 0:a.layout)||""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-layout--hidden":""}"
    >
        ${(e==null?void 0:e.label)&&i`
            <div className="fc-layout__heading">
                <span>${e.label}</span>
            </div>
        `}
        <div className="fc-layout__wrapper">
            ${(t=e.layoutFields)==null?void 0:t.map(n=>{var c,l;return(l=(c=window.formcentric.formapp.templates)==null?void 0:c[n.type])==null?void 0:l.call(c,i,n)})}
        </div>
    </div>`},fe=(i,e)=>{var a,d,t,n,c,l,f,m,u,$,r;return i`
    <div
        className="
fc-field ${(a=e.properties)!=null&&a.hint?"fc-field--has-hint":""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-field--hidden":""} ${e!=null&&e.fieldError?"fc-field--has-error":""} ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <div className="fc-textinput ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""}">
            <div className="fc-textinput__input">
                <input
                    autocomplete=${(l=e.properties)==null?void 0:l.autocomplete}
                    key="${e.name}"
                    type="text"
                    inputmode="decimal"
                    ...${{id:e.id,name:e.name,defaultValue:e.value,disabled:(f=e.properties)==null?void 0:f.disabled,placeholder:((m=e.properties)==null?void 0:m.placeholder)||"",oninput:e.oninput,onfocus:e.onfocus,readonly:(u=e.properties)==null?void 0:u.readonly,onblur:e.onblur,required:($=e.properties)==null?void 0:$.mandatory,"aria-errormessage":`fc-error-${e.id}`,"aria-invalid":!!((r=e.fieldError)!=null&&r.defaultMessage),"aria-describedby":`fc-hint-${e.id}`}}
                />
            </div>
            <div class="fc-textinput__label">
                ${window.formcentric.formapp.components.label(i,e)}
                ${window.formcentric.formapp.components.hint(i,e)}
            </div>
            ${window.formcentric.formapp.components.shortHint(i,e)}
            ${window.formcentric.formapp.components.error(i,e)}
        </div>
    </div>
`},me=(i,e)=>{var a,d,t;return i`
    <div
        className="fc-field ${(a=e==null?void 0:e.properties)!=null&&a.hidden?"fc-field--hidden":""} ${e!=null&&e.fieldError?"fc-field--has-error":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${(d=e==null?void 0:e.properties)!=null&&d.field_width?(t=e==null?void 0:e.properties)==null?void 0:t.field_width:""}"
    >
        ${e.components.markdown({markdown:e.value,props:e})}
    </div>
`},ue=(i,e)=>{var a,d,t,n,c,l,f,m,u,$;return i`
    <div
        className="fc-field ${(a=e.properties)!=null&&a.hint?"fc-field--has-hint":""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-field--hidden":""} ${e!=null&&e.fieldError?"fc-field--has-error":""} ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <div className="fc-textinput ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""}">
            <div className="fc-textinput__input">
                <input
                    type="password"
                    ...${{id:e.id,key:e.id,name:e.name,defaultValue:e.value,disabled:(l=e.properties)==null?void 0:l.disabled,placeholder:((f=e.properties)==null?void 0:f.placeholder)||"",oninput:e.oninput,onfocus:e.onfocus,readonly:(m=e.properties)==null?void 0:m.readonly,onblur:e.onblur,required:(u=e.properties)==null?void 0:u.mandatory,"aria-errormessage":`fc-error-${e.id}`,"aria-invalid":!!(($=e.fieldError)!=null&&$.defaultMessage),"aria-describedby":`fc-hint-${e.id}`}}
                />
            </div>
            <div class="fc-textinput__label">
                ${window.formcentric.formapp.components.label(i,e)}
                ${window.formcentric.formapp.components.hint(i,e)}
            </div>
            ${window.formcentric.formapp.components.shortHint(i,e)}
            ${window.formcentric.formapp.components.error(i,e)}
        </div>
    </div>
`},$e=(i,e)=>{var a,d,t,n,c,l,f,m,u,$,r;return i`
    <div
        className="fc-field ${(a=e.properties)!=null&&a.hint?"fc-field--has-hint":""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-field--hidden":""} ${e!=null&&e.fieldError?"fc-field--has-error":""} ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <div className="fc-textinput ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""}">
            <div className="fc-textinput__input">
                <input
                    autocomplete=${(l=e.properties)==null?void 0:l.autocomplete}
                    type="tel"
                    ...${{id:e.id,key:e.id,name:e.name,defaultValue:e.value,disabled:(f=e.properties)==null?void 0:f.disabled,placeholder:((m=e.properties)==null?void 0:m.placeholder)||"",oninput:e.oninput,onfocus:e.onfocus,readonly:(u=e.properties)==null?void 0:u.readonly,onblur:e.onblur,required:($=e.properties)==null?void 0:$.mandatory,"aria-errormessage":`fc-error-${e.id}`,"aria-invalid":!!((r=e.fieldError)!=null&&r.defaultMessage),"aria-describedby":`fc-hint-${e.id}`}}
                />
            </div>
            <div class="fc-textinput__label">
                ${window.formcentric.formapp.components.label(i,e)}
                ${window.formcentric.formapp.components.hint(i,e)}
            </div>
            ${window.formcentric.formapp.components.shortHint(i,e)}
            ${window.formcentric.formapp.components.error(i,e)}
        </div>
    </div>
`},re=(i,e)=>{var a,d,t,n,c,l,f,m;return i`
    <div
        className="
fc-field ${(a=e.properties)!=null&&a.hint?"fc-field--has-hint":""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-field--hidden":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <div className="fc-picture ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""}">
            <div className="fc-picture__wrapper">
                <img
                    src=${(f=(l=e.properties)==null?void 0:l.pictureUrl)==null?void 0:f.original}
                    alt=${(m=e.properties)==null?void 0:m.alt}
                />
            </div>
        </div>
    </div>
`},ve=(i,e)=>{var a,d,t,n,c,l,f;return i`
    <div
        className="fc-field ${(a=e.properties)!=null&&a.hint?"fc-field--has-hint":""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-field--hidden":""} ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <fieldset
            className="fc-fieldset ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""}"
            disabled=${(l=e.properties)==null?void 0:l.disabled}
        >
            <legend className="fc-fieldset__legend">${window.formcentric.formapp.components.label(i,e)}</legend>
            ${window.formcentric.formapp.components.imageEmbed(i,e,"original")}
            <div className="fc-fieldset__options">
                ${(f=e.children)==null?void 0:f.map(m=>window.formcentric.formapp.components.radioOption(i,e,m))}
            </div>
            ${window.formcentric.formapp.components.hint(i,e)}
            ${window.formcentric.formapp.components.shortHint(i,e)}
            ${window.formcentric.formapp.components.error(i,e)}
        </fieldset>
    </div>
`},we=(i,e)=>{var a,d,t,n,c,l,f,m,u,$,r,v;return i`
    <div
        className="fc-field ${(a=e.properties)!=null&&a.hint?"fc-field--has-hint":""} ${e!=null&&e.fieldError?"fc-field--has-error":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-field--hidden":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <div className="fc-textinput ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""}">
            <div className="fc-textinput__input">
                <input
                    autocomplete=${(l=e.properties)==null?void 0:l.autocomplete}
                    type="text"
                    id=${e.id}
                    key=${e.id}
                    name=${e.name}
                    defaultValue=${e.value}
                    oninput=${e.oninput}
                    onfocus=${e.onfocus}
                    onblur=${e.onblur}
                    maxlength=${(f=e.properties)==null?void 0:f.maxlength}
                    disabled=${(m=e.properties)==null?void 0:m.disabled}
                    placeholder=${((u=e.properties)==null?void 0:u.placeholder)||""}
                    readonly=${($=e.properties)==null?void 0:$.readonly}
                    required=${(r=e.properties)==null?void 0:r.mandatory}
                    aria-errormessage=${`fc-error-${e.id}`}
                    aria-invalid=${!!((v=e.fieldError)!=null&&v.defaultMessage)}
                    aria-describedby=${`fc-hint-${e.id}`}
                />
                ${window.formcentric.formapp.components.counter(i,e)}
            </div>
            <div class="fc-textinput__label">
                ${window.formcentric.formapp.components.label(i,e)}
                ${window.formcentric.formapp.components.hint(i,e)}
            </div>
            ${window.formcentric.formapp.components.shortHint(i,e)}
            ${window.formcentric.formapp.components.error(i,e)}
        </div>
    </div>
`},he=(i,e)=>{var a,d,t,n,c;return i`
    <div
        className="fc-field ${(a=e==null?void 0:e.properties)!=null&&a.hidden?"fc-field--hidden":""} ${(d=e.properties)!=null&&d.hint?"fc-field--has-hint":""} ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${e!=null&&e.fieldError?"fc-field--has-error":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <div className="fc-signature ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""} ">
            <div className="fc-signature__canvas">${e.components.signature(e)}</div>
            <div class="fc-signature__label">
                ${window.formcentric.formapp.components.label(i,e)}
                ${window.formcentric.formapp.components.hint(i,e)}
            </div>
            ${window.formcentric.formapp.components.shortHint(i,e)}
            ${window.formcentric.formapp.components.error(i,e)}
        </div>
    </div>
`},_e=(i,e)=>{var t;const a=n=>{var c,l,f;return i`<img
            alt=${e.translation("summary.list",{context:"image_signature"})}
            style="aspect-ratio:${((l=(c=n.data)==null?void 0:c.properties)==null?void 0:l.aspect_ratio)||"4:1"};max-width:100%;"
            src=${e.signatures[(f=n.data)==null?void 0:f.name]}
        />`},d=n=>n.data.value===""?e==null?void 0:e.fieldEmptyText:{signature:a(n)}[n.data.type]||n.data.value;return i`
        <div className="fc-summary ${(t=e==null?void 0:e.properties)!=null&&t.hidden?"fc-field--hidden":""}">
            <div
                id=${`fc-summary__heading-${e.id}`}
                className="fc-summary__heading"
            >
                ${e.label}
            </div>

            <ul
                id=${e.id}
                className="fc-summary__list"
                aria-labelledby=${`fc-summary__heading-${e.id}`}
            >
                ${e==null?void 0:e.summaryFields.map(n=>i`
                        <li className="fc-summary__field">
                            <p
                                aria-hidden="true"
                                className="fc-summary__label"
                            >
                                ${n.data.label}
                            </p>
                            <p
                                aria-hidden="true"
                                className="fc-summary__value"
                            >
                                ${d(n)}
                            </p>
                            <span className="fc-sr-only">${n.data.label}: ${d(n)}</span>
                        </li>
                    `)}
            </ul>
            ${window.formcentric.formapp.components.error(i,e)}
        </div>
    `},be=(i,e)=>{var a,d,t,n,c,l,f,m,u,$,r,v,h,_,b,g;return i`
    <div
        className="fc-field ${(a=e.properties)!=null&&a.hint?"fc-field--has-hint":""} ${e!=null&&e.fieldError?"fc-field--has-error":""} ${e!=null&&e.fieldSuccess?"fc-field--is-valid":""} ${e!=null&&e.fieldFocused?"fc-field--focused":""} ${(d=e==null?void 0:e.properties)!=null&&d.hidden?"fc-field--hidden":""} ${(t=e==null?void 0:e.properties)!=null&&t.field_width?(n=e==null?void 0:e.properties)==null?void 0:n.field_width:""}"
    >
        <div
            className="fc-textarea ${(c=e==null?void 0:e.properties)!=null&&c.style_class?e==null?void 0:e.properties.style_class:""} ${(l=e.properties)!=null&&l.rows?"fc-textarea--rows":""} ${(f=e.properties)!=null&&f.cols?"fc-textarea--cols":""}"
        >
            <div className="fc-textarea__textarea">
                <textarea
                    name=${e.name}
                    id=${e.id}
                    key=${e.id}
                    oninput=${e.oninput}
                    onfocus=${e.onfocus}
                    onblur=${e.onblur}
                    defaultValue=${e.value}
                    placeholder=${((m=e.properties)==null?void 0:m.placeholder)||""}
                    autocomplete=${(u=e.properties)==null?void 0:u.autocomplete}
                    disabled=${($=e.properties)==null?void 0:$.disabled}
                    readonly=${(r=e.properties)==null?void 0:r.readonly}
                    maxlength=${(v=e.properties)==null?void 0:v.maxlength}
                    rows=${(h=e.properties)==null?void 0:h.rows}
                    cols=${(_=e.properties)==null?void 0:_.cols}
                    required=${(b=e.properties)==null?void 0:b.mandatory}
                    aria-errormessage=${`fc-error-${e.id}`}
                    aria-invalid=${!!((g=e.fieldError)!=null&&g.defaultMessage)}
                    aria-describedby=${`fc-hint-${e.id}`}
                />
                ${window.formcentric.formapp.components.counter(i,e)}
            </div>
            <div class="fc-textarea__label">
                ${window.formcentric.formapp.components.label(i,e)}
                ${window.formcentric.formapp.components.hint(i,e)}
            </div>
            ${window.formcentric.formapp.components.shortHint(i,e)}
            ${window.formcentric.formapp.components.error(i,e)}
        </div>
    </div>
`},ge={button:O,calculatedValue:G,captcha:Y,checkBoxGroup:Z,comboBox:p,content:ee,dateField:ie,emailField:ae,fieldSet:te,fileUpload:de,hiddenField:ne,inputField:ce,layout:le,numberField:fe,paragraph:me,passwordField:ue,phoneField:$e,picture:re,radioGroup:ve,shortText:we,summary:_e,textArea:be,signature:he},oe=i=>i`<div className="fc-form__logo"></div>`,ye=(i,e)=>e!=null&&e.pageTitle?i`<div className="fc-form__header">
              ${e!=null&&e.pageTitle?i`<p className="fc-form__page-title">${e.pageTitle}</p>`:null}
          </div>`:null,Ne=(i,e)=>{const{_cancel:a,_finish:d,_back:t,_next:n,pageCount:c,currentPage:l}=e,f=[];let m="";for(var u=1;u<=c;u++)u===l?m="active":u<l?m="finished":m="",f.push(i`<div className="fc-pagination__steps__item ${m}"></div>`);const $=i`<div
        className="fc-pagination"
        role="progressbar"
        tabindex="0"
        aria-label="${e.translation("progress")}"
        aria-valuemin="1"
        aria-valuemax="${c}"
        aria-valuenow="${l}"
    >
        <span className="fc-pagination__steps"> ${f} </span>
        <span className="fc-pagination__label">${e.translation("page")} </span>
        <span className="fc-pagination__current">${l}</span>
        <span className="fc-pagination__separator">/</span>
        <span className="fc-pagination__total">${c}</span>
    </div>`;return i`
        <div className="fc-form__footer">
            <div className="fc-form-actions">
                ${window.formcentric.formapp.components.button(i,t)}
                ${window.formcentric.formapp.components.button(i,n)}
                ${window.formcentric.formapp.components.button(i,d)}
                ${window.formcentric.formapp.components.button(i,a)}
            </div>
            ${c>1&&$}
        </div>
    `},xe={formFooter:Ne,formPageTitle:ye,formLogo:oe},Ee=(i,e)=>{var a,d,t;return i`<div className="fc-viewError">
        <svg
            width="120"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            className="fc-viewError--icon"
        >
            <g
                fill="none"
                fillRule="evenodd"
            >
                <path
                    className="fc-viewError--icon__fill"
                    d="M10.582 2.188a1.25 1.25 0 00-1.618.407l-.07.117-6.687 12.706a1.25 1.25 0 00.978 1.826l.128.006h13.374a1.25 1.25 0 001.163-1.708l-.057-.124-6.687-12.706a1.25 1.25 0 00-.524-.524z"
                    fillRule="nonzero"
                />
                <path
                    className="fc-viewError--icon__outline"
                    d="M7.566 2.013a2.75 2.75 0 014.764-.18l.104.18L19.12 14.72a2.75 2.75 0 01-2.211 4.022l-.223.009H3.313a2.75 2.75 0 01-2.53-3.83l.096-.2L7.566 2.012zm3.016.175a1.25 1.25 0 00-1.618.407l-.07.117-6.687 12.706a1.25 1.25 0 00.978 1.826l.128.006h13.374a1.25 1.25 0 001.163-1.708l-.057-.124-6.687-12.706a1.25 1.25 0 00-.524-.524zM10.15 13a1 1 0 011 1v.4a1 1 0 01-1 1h-.4a1 1 0 01-1-1V14a1 1 0 011-1h.4zM11 5.5l-.25 6.333h-1.5L9 5.5h2z"
                    fillRule="nonzero"
                />
            </g>
        </svg>
        <h2>${(t=(a=e==null?void 0:e.error)==null?void 0:a.message)!=null?t:(d=e==null?void 0:e.error)==null?void 0:d.error}</h2>
    </div>`},ke=(i,e)=>{const{actions:a}=e,d=a==null?void 0:a.pop(),{data:t={}}=d||{},n=i` <svg
        width="120"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
    >
        <g
            fill="none"
            fillRule="evenodd"
        >
            >
            <path
                d="M16.687 4.5a.75.75 0 01.061 1.059L8.52 14.798a1 1 0 01-1.411.081l-.054-.05-3.843-3.97a.75.75 0 01.995-1.118l.083.075 3.467 3.582 7.872-8.837a.75.75 0 011.059-.061z"
                fill="#50C488"
                fillRule="nonzero"
            />
        </g>
    </svg>`;return i`
        <div className="fc-success">
            ${!(t!=null&&t.note)&&n} ${e.components.markdown({markdown:t==null?void 0:t.note,data:t})}
        </div>
    `},se=(i,e)=>{const{actions:a}=e,d=a[a.length-1],{data:t={}}=d;if(t!=null&&t.url){let c=function(){return t==null?void 0:t.url};const n=(t==null?void 0:t.delay)*1e3;if(console.debug("Redirecting to: ",t==null?void 0:t.url,n),setTimeout(()=>{console.debug("Redirecting to... "),window.location.replace(c())},n),n===0)return null}return i` <div className="fc-success">${e.components.markdown({markdown:t==null?void 0:t.note,data:t})}</div> `},Fe=(i,e)=>{const{actions:a}=e,d=a[a.length-1],{data:t={}}=d||{},n=i` <svg
        width="120"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
    >
        <g
            fill="none"
            fillRule="evenodd"
        >
            >
            <path
                d="M16.687 4.5a.75.75 0 01.061 1.059L8.52 14.798a1 1 0 01-1.411.081l-.054-.05-3.843-3.97a.75.75 0 01.995-1.118l.083.075 3.467 3.582 7.872-8.837a.75.75 0 011.059-.061z"
                fill="#50C488"
                fillRule="nonzero"
            />
        </g>
    </svg>`;return i`
        <div className="fc-success">
            ${!(t!=null&&t.note)&&n} ${e.components.markdown({markdown:t==null?void 0:t.note,data:t})}
        </div>
    `},Me={error:Ee,optin:ke,redirect:se,success:Fe};window!=null&&window.formcentric||(window.formcentric={});var E;(E=window==null?void 0:window.formcentric)!=null&&E.formapp||(window.formcentric.formapp={});var k,s;(s=(k=window==null?void 0:window.formcentric)==null?void 0:k.formapp)!=null&&s.components||(window.formcentric.formapp.components={});var F,M;(M=(F=window==null?void 0:window.formcentric)==null?void 0:F.formapp)!=null&&M.templates||(window.formcentric.formapp.templates={});window.formcentric.formapp.components=D;window.formcentric.formapp.templates=w(w(w({},ge),xe),Me);
})();